import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { ContainerInput } from '@trackback/widgets';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import parsed from '@app/utils/parsed';

@Component({
  selector: 'tb-container',
  imports: [DynamicWidgetDirective],
  template: `
    @for (child of input().children; track $index) {
      <ng-container [dynamicWidget]="child" [context]="context()" />
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'parsedClasses()',
  },
})
export default class ContainerComponent extends WidgetInputBaseComponent<ContainerInput> {
  parsedClasses = parsed(this.inputProp('styleClasses'), this.context);
}
